var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('p',{style:({
        textAlign: 'left',
        fontSize: '12px',
        margin: '8px 10px',
        fontWeight: 600,
      })},[_vm._v("\n      门禁通过情况\n    ")]),_c('v-chart',{style:({ height: '300px', width: '420px' }),attrs:{"options":_vm.OutInData,"auto-resize":true,"theme":"macarons"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }